
import {
    CLOSE_ACTION_TYPE,
    GET_OBJECT_INFO_ACTION_TYPE,
    SET_OBJECT_INFO,
    SHOW_ACTION_TYPE
} from '../sagas/info';

import {
    GET_PROJECT_ACTION_TYPE
} from '../sagas/project';

import {
    ISKN_EXPLORER_SET_ISKN_DATE_ACTION_TYPE,
} from '../sagas/isknExplorer';

import {initialState as loaderInitialState, createLoaderReducer} from '../common/client/reducers/loader';

const initialState = {
    ...loaderInitialState,
    type: '',
    visible: false
};

export function getObjectInfo(state) {
    return state.data?.result?.result;
}

export default function createReducer() {
    const loaderReducer = createLoaderReducer(GET_OBJECT_INFO_ACTION_TYPE);

    return (state = initialState, action) => {
        switch (action.type) {

            case CLOSE_ACTION_TYPE:
                return {
                    ...state,
                    visible: false
                };

            case SET_OBJECT_INFO:
                return {
                    ...state,
                    visible: true,
                    data: {
                        result: action.data
                    }
                }

            case SHOW_ACTION_TYPE:
                return {
                    ...state,
                    visible: true
                };

            case ISKN_EXPLORER_SET_ISKN_DATE_ACTION_TYPE:
                return {
                    ...initialState
                };

            case GET_PROJECT_ACTION_TYPE.DEFAULT:
                return {
                    ...initialState
                };

            default:
                return loaderReducer(state, action);
        }
    };
}
